import PropTypes from 'prop-types';
import React, { lazy, Suspense, useEffect, useState, useRef, useCallback } from 'react';
import { ClientOnly } from '@atc/react-client-only';

// lazy load to reduce the bundle size
import { jsx as _jsx } from "react/jsx-runtime";
const Popper = /*#__PURE__*/lazy(() => import(/* webpackChunkName: "popperComponent" */
'./Popper'));
function Overlay(_ref) {
  let {
    placement,
    target,
    show,
    container,
    children,
    rootClose,
    onHide = () => {},
    onEnter = () => {},
    enableFlip = true,
    ...rest
  } = _ref;
  const prevShowOverlay = useRef(show);
  const [showOverlay, setShowOverlay] = useState(show);
  const handleHide = useCallback(() => {
    if (showOverlay && prevShowOverlay?.current) {
      setShowOverlay(false);
      onHide();
    }
  }, [onHide, showOverlay]);
  useEffect(() => {
    if (show !== showOverlay) {
      setShowOverlay(show);
    }
  }, [show, showOverlay]);
  useEffect(() => {
    if (rootClose) {
      if (showOverlay) {
        document.addEventListener('click', handleHide);
      } else {
        document.removeEventListener('click', handleHide);
      }
    }
    if (!showOverlay) {
      handleHide();
    }
    prevShowOverlay.current = showOverlay;
    return () => {
      prevShowOverlay.current = false;
    };
  }, [handleHide, rootClose, showOverlay]);
  return /*#__PURE__*/_jsx(ClientOnly, {
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: null,
      children: showOverlay && /*#__PURE__*/_jsx(Popper, {
        target: target,
        placement: placement,
        overlay: children,
        onEnter: onEnter,
        container: container,
        enableFlip: enableFlip,
        ...rest
      })
    })
  });
}
export default Overlay;